import { Container, Stack, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import GoBack from "../GoBack";
import GridLayout from "../GridLayout";
import Loading from "../Loading";
import Navbar from "../Navbar";
import PostCard from "../PostCard";
import Sidebar from "../Sidebar";
import { useParams } from "react-router-dom";
import { getPost } from "../../api/posts";
import Comments from "../Comments";
import ErrorAlert from "../ErrorAlert";
import { isLoggedIn } from "../../helpers/authHelper";

const PostView = () => {
  const params = useParams();

  const [post, setPost] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const user = isLoggedIn();

  const fetchPost = async () => {
    setLoading(true);
    const data = await getPost(params.id, user && user.token);
    if (data.error) {
      setError(data.error);
    } else {
      setPost(data);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchPost();
  }, [params.id]);

  return (
    <Box sx={{ backgroundColor: "#F5F5F5", minHeight: "100vh" }}>
      <Navbar />
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <GoBack />
        <GridLayout
          left={
            loading ? (
              <Loading />
            ) : post ? (
              <Stack spacing={3}>
                <PostCard post={post} key={post._id} />
                <Comments />
              </Stack>
            ) : (
              error && <ErrorAlert error={error} />
            )
          }
          right={<Sidebar />}
        />
      </Container>
    </Box>
  );
};

export default PostView;
